import { render, staticRenderFns } from "./upload-audio-qcloud.vue?vue&type=template&id=ec4d179a&scoped=true&"
import script from "./upload-audio-qcloud.vue?vue&type=script&lang=ts&"
export * from "./upload-audio-qcloud.vue?vue&type=script&lang=ts&"
import style0 from "./upload-audio-qcloud.vue?vue&type=style&index=0&id=ec4d179a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d179a",
  null
  
)

export default component.exports